<template>
  <div class="pre-fundDetailForm-container blue-avue-form">
    <InfoContainer
      :infoTitle="InfoContainerConfig['infoTitle']"
      :contentConfig="InfoContainerConfig['infoContent']"
      class="comment-container"
    >
      <template slot="basicInfo">
        <!-- <CommonDetail
          :configArray="addFormConfig.column"
          :initValue="addFormInfo"
        /> -->
        <template v-if="disabled">
            <CommonDetail
                  :configArray="detailFormConfig"
                  :initValue="addFormInfo"
                  class="common_detail"
            >
              <template #managerDeptName>
              
                <div class="add-fund-manager" >
                  <SelectInput
                    :disabled="true"
                    bindLabel="managerDeptName"
                    bindKey="id"
                    bindValue="managerDeptName"
                    dataUrl="fund/fdmanagerdept/page"
                    methods="get"
                    dataMethod="params"
                    searchKey="managerDeptName"
                    :initParam="{ deptType:2  }"                
                    :bindId="addFormInfo.managerDeptId ? addFormInfo.managerDeptId : ''"
                    @handleChange="setDeptInfo" />
                </div>
              </template>
            
            </CommonDetail>
        </template>
        <template v-else >
          <avue-form
            ref="form"
            v-model="addFormInfo"
            :option="addFormConfig"
            @submit="submitForm"
            :loading="loading"
          >
            <template slot="masterName">
              <SelectInput
                bindLabel="name"
                :allowCreate="false"
                searchKey="dictValue"
                bindKey="id"
                methods="get"
                dataMethod="params"
                :initParam="{
                  bizType: 3,
                }"
                dataUrl="fund/master/page"
                @handleChange="(el) => changeMasterId(el)"
                :bindId="addFormInfo['masterId'] ? addFormInfo['masterId'] : ''"
              />
            </template>
            <template slot="region">
              <el-cascader  :options="options" v-model="addFormInfo.region">
              </el-cascader>
            </template>
            <template #fdManagerName>
              <!-- <el-input  v-model="addFormInfo.fdManagerName" placeholder="请输入基金管理人"
                :disabled="true"></el-input> -->
              <div class="add-fund-manager" >
                <SelectInput bindLabel="name" bindKey="id" bindValue="name" dataUrl="fund/manager/page" methods="get"
                  dataMethod="params" searchKey="name" :bindId="
                    addFormInfo.managerId ? addFormInfo.managerId : ''
                  " @handleChange="setManagerInfo" />
                <div class="add-button el-icon-plus" @click="showAddFundManager">
                  添加
                </div>
              </div>
            </template>

          </avue-form>
        </template>
      </template>
    </InfoContainer>

    <SelectPerson
      ref="selectperson"
      :checkUserList="checkUserList"
      :isOnly="false"
      :clear="false"
      @setPeople="setPeople"
    />
    <AddFundManager ref="addFundManager" @addPersonForm="setManagerInfo" />
  </div>
</template>
<script>
import InfoContainer from "@/components/infoContainer/fundInfoContainer";
import { subFundAddConfig,subFundDetailConfig } from "../config";
import AddFundManager from "@/components/fundComponent/addFundManager";
import { mapGetters } from "vuex";
import WordUpload from "@/components/wordUpload/wordUpload";
import SelectInput from "@/components/commonSelect/selectInput";
import SelectPerson from "@/components/SelectPersonnel/person";
import CommonDetail from "@/components/commonDetail/fundCommonDetail";
import TableCustom from "@/components/tableCustom/tableCustom";
import { regionData, TextToCode, CodeToText } from "element-china-area-data";
import {
  isvalidatemobile,
  isvalidateMoney,
  isvalidatePercentage,
} from "@/util/validate";
export default {
  name: "fundDetailForm",

  data() {
    const validatePhone = (rule, value, callback) => {
      if (value != "" && isvalidatemobile(value)[0]) {
        callback(new Error(isvalidatemobile(value)[1]));
      } else {
        callback();
      }
    };
    

    return {
      checkUserList: [],
      deptInfo: {},
      files: [],
      visitTime: "",
      addFormInfo: {
        basicManager: {},
        basicTrustee: {},
        basicInvestors: [
          {
            capitals: [{}],
          },
        ],
      },
      addFormConfig: subFundAddConfig(
        this.changeNumMoneyToChinese,
        isvalidateMoney,
        validatePhone,
        this.changeThirdParty
        
      ),
      detailFormConfig:subFundDetailConfig(this.getMoney),
      InfoContainerConfig: {
        infoTitle: "基本信息",
        infoContent: [
          {
            title: "",
            prop: "basicInfo",
          },
          {
            title: "",
            prop: "tableInfo",
          },
          {
            title: "",
            prop: "investor",
          },
        ],
      },

      baFileMenuId: "",

      options: regionData,
      firstQuery: true,
      loading: false,
      dialogShow: false,
      // projectAddress: [],
    };
  },
  components: {
    SelectPerson,
    InfoContainer,
    WordUpload,
    CommonDetail,
    TableCustom,
    SelectInput,
    AddFundManager,
  },
  props: {
    id: {
      type: String,
      default: "",
    },
    isDetail: {
      type: Boolean,
      default: false,
    },
    disabled: {
      type: Boolean,
      default: false,
    },
    // 传入的详细数据
    bindData: {
      type: Object,
      default: () => {
        return {};
      },
    },
  },
  watch: {
    "addFormInfo.investDate1": {
      handler(val) {
        if (val) {
          this.addFormInfo.fundInvestDateBegin = val[0];
          this.addFormInfo.fundInvestDateEnd = val[1];
        }
      },
      immediate: true,
    },
    "addFormInfo.quitDate1": {
      handler(val) {
        if (val) {
          this.addFormInfo.fundQuitDateBegin = val[0];
          this.addFormInfo.fundQuitDateEnd = val[1];
        }
      },
      immediate: true,
    },
    "addFormInfo.clearingDate1": {
      handler(val) {
        if (val) {
          this.addFormInfo.fundClearingDateBegin = val[0];
          this.addFormInfo.fundClearingDateEnd = val[1];
        }
      },
      immediate: true,
    },
    disabled: {
      handler(val) {
        this.addFormConfig.column.filter((item, index) => {
          // if (
          //   ![
          //     "name",
          //     "masterName",
          //     "isDirectional",
          //     "cooperateType",
          //     "govIndustrySubscribed",
          //     "realGovIndustrySubscribed",
          //     "fdManagerName",
          //     "manageCycle",
          //   ].includes(item.prop)
          // ) {
          //   item.disabled = this.disabled;
          // }
        });
      },
      deep: true,
      immediate: true,
    },
    addFormInfo: {
      handler(val) {
        if (this.$refs.form) {
          this.$refs.form.clearValidate();
        }
      },
    },
    bindData: {
      handler(newData, oldData) {
        let addFormInfo = JSON.parse(JSON.stringify(newData));
        if (addFormInfo.fundInvestDateBegin) {
          addFormInfo.investDate1 = [
            addFormInfo.fundInvestDateBegin,
            addFormInfo.fundInvestDateEnd,
          ];
          addFormInfo.quitDate1 = [
            addFormInfo.fundQuitDateBegin,
            addFormInfo.fundQuitDateEnd,
          ];
          addFormInfo.clearingDate1 = [
            addFormInfo.fundClearingDateBegin,
            addFormInfo.fundClearingDateEnd,
          ];
        }
        this.addFormInfo = addFormInfo;
      },
    },
    dateRange: {
      handler(data) {
        this.$nextTick(() => {
          if (
            this.addFormInfo.peScale &&
            this.addFormInfo.govIndustrySubscribed
          ) {
            if (
              parseFloat(this.addFormInfo.peScale) >=
              parseFloat(this.addFormInfo.govIndustrySubscribed)
            ) {
              this.addFormInfo.otherCapitalSubscribed =
                this.addFormInfo.peScale -
                this.addFormInfo.govIndustrySubscribed;
              this.addFormInfo.capitalRatio = (
                (this.addFormInfo.govIndustrySubscribed /
                  this.addFormInfo.peScale) *
                100
              ).toFixed(2);
            } else {
              this.addFormInfo.otherCapitalSubscribed = "";
              this.addFormInfo.capitalRatio = "";
            }
          }
        });
      },
      deep: true,
    },
  },
  computed: {
    ...mapGetters(["userInfo"]),
    dateRange() {
      const { peScale, govIndustrySubscribed } = this.addFormInfo;
      return { peScale, govIndustrySubscribed };
    },
  },
  mounted() {
    // 详细页不执行查询详情操作
    // this.addFormConfig.column.filter((item, index) => {
    //   if (!item.disabled) {
    //     item.disabled = this.disabled;
    //   }
    //   if (this.subFundsAdd) {
    //     item.disabled = false;
    //   }
    // });
    if (this.$route.params.id && this.$route.params.id != -1) {
      // 查询投放管理详细信息
      // this.queryDetailData()
      // if (this.isDetail) {
      //   this.InfoContainerConfig.infoTitle = "项目信息";
      // } else {
      //   this.InfoContainerConfig.infoTitle = "编辑基金项目";
      // }

      this.$forceUpdate();
    }
  },

  methods: {
    //第三方选聘
    changeThirdParty(val) {
        this.$emit('changeThirdParty', val)

      },
    showAddFundManager() {
      this.$refs.addFundManager.showblock();
    },
    setManagerInfo(data) {
      this.addFormInfo.managerEstablishmentTime = data.establishmentTime;
      this.addFormInfo.region = data.region
       
      this.addFormInfo.address = data.address;
      this.addFormInfo.creditCode = data.creditCode;
      this.addFormInfo.orgCode = data.orgCode;
      this.addFormInfo.contactPerson = data.contactPerson;
      this.addFormInfo.contactInfo = data.contactInfo;
      this.addFormInfo.duty = data.duty;

      this.addFormInfo.fdManagerName = data.name;
      this.addFormInfo.managerId = data.id;
    },

    toChinesNum(num) {
      let changeNum = [
        "零",
        "一",
        "二",
        "三",
        "四",
        "五",
        "六",
        "七",
        "八",
        "九",
      ];
      let unit = ["", "十", "百", "千", "万"];
      num = parseInt(num);
      let getWan = (temp) => {
        let strArr = temp.toString().split("").reverse();
        let newNum = "";
        for (var i = 0; i < strArr.length; i++) {
          newNum =
            (i == 0 && strArr[i] == 0
              ? ""
              : i > 0 && strArr[i] == 0 && strArr[i - 1] == 0
              ? ""
              : changeNum[strArr[i]] + (strArr[i] == 0 ? unit[0] : unit[i])) +
            newNum;
        }
        return newNum;
      };
      let overWan = Math.floor(num / 10000);
      let noWan = num % 10000;
      if (noWan.toString().length < 4) {
        noWan = "0" + noWan;
      }
      return overWan ? getWan(overWan) + "万" + getWan(noWan) : getWan(num);
    },

    
    
    validForm() {
      let self = this;

      return new Promise((resolve, reject) => {
        self.$refs.form.validate((valid, done) => {
          if (valid) {
            done();
            resolve(true);
          }else {
            this.$message.warning('请将表单内容补充完整')
          }
        });
      });
    },
    changeMasterId(el) {
      if (el) {
        this.addFormInfo.masterId = el.id;
        this.addFormInfo.masterName = el.name;
      }
    },
  },
};
</script>
<style lang="scss" scoped>
.pre-fundDetailForm-container {
  margin-top: 10px;

  .button-container {
    text-align: center;
  }
}

.comment-container {
  margin-top: 0px;

  /deep/.detail-one {
    padding-top: 0 !important;
    padding-bottom: 0 !important;
    padding-left: 0 !important;
    padding-right: 0 !important;
  }

  /deep/.comment-container {
    margin-top: 0 !important;
  }
}

.travel_tips {
  margin-top: 10px;
}

.display_flex {
  display: flex;
  color: #ff9900;
  align-items: center;
}

.table_info {
  padding: 0 20px;
}

.table_info_border {
  border: 1px dashed #afd1f8;
  width: 100%;
  margin-bottom: 40px;
}

.table_wrapper {
  text-align: center;
  width: 100%;
  margin: auto;

  th,
  td {
    height: 40px;
    line-height: 40px;
  }

  tr:nth-child(1) {
    width: 240px;
  }

  .first_td {
    width: 120px;
  }
}

.investor_wrapper {
  text-align: center;

  .investor_title {
    color: #333333;
    font-size: 18px;
    font-weight: 700;
    padding-bottom: 20px;
  }
}

/deep/ .el-input-number {
  width: 100%;
  text-align: left;
}

/deep/ .el-input__inner {
  text-align: left;
}

/deep/.el-date-editor.el-input {
  width: 100%;
}

.investor_list {
  padding: 20px;
  position: relative;

  /deep/.el-form-item {
    margin-bottom: 4px;
  }

  .close_btn {
    border-width: 0px;
    position: absolute;
    right: 8.44%;
    top: 0px;
    width: 24px;
    height: 24px;
    background: inherit;
    background-color: rgba(64, 158, 255, 1);
    border: none;
    border-radius: 50px;
    -moz-box-shadow: none;
    -webkit-box-shadow: none;
    box-shadow: none;
    font-weight: 300;
    font-style: normal;
    font-size: 18px;
    color: #ffffff;
    z-index: 2;
    cursor: pointer;

    .text {
      align-self: center;
      box-sizing: border-box;
      width: 100%;
    }
  }

  .index_number {
    border-width: 0px;
    position: absolute;
    left: 30px;
    top: 0px;
    min-width: 24px;
    height: 24px;
    background: inherit;
    background-color: rgba(64, 158, 255, 1);
    border: none;
    border-radius: 50px;
    -moz-box-shadow: none;
    -webkit-box-shadow: none;
    box-shadow: none;
    font-weight: 300;
    font-style: normal;
    font-size: 18px;
    color: #ffffff;
    z-index: 2;
    cursor: pointer;

    .text {
      align-self: center;
      box-sizing: border-box;
      width: 100%;
    }
  }
}

.qishu_wrapper {
  display: flex;
  align-items: center;
}

.change_qishu {
  // padding-left: 10px;
  display: flex;
  align-items: center;
  cursor: pointer;
  margin-top: 10px;

  i {
    padding-right: 4px;
  }
}

.table_custom_add {
  padding: 20px 0;
  text-align: center;

  /deep/ .el-button {
    width: 50%;
    color: #469eff;
    border: 1px dashed #469eff;
  }
}

.bottom-container {
  width: 100%;
  height: 70px;
  position: fixed;
  // z-index: 1000;
  bottom: 0px;
  left: 0px;
  z-index: 1000;
  background-color: #fff;
  box-shadow: 0px -8px 10px rgba(0, 0, 0, 0.05);

  .button-container {
    width: 93%;
    height: 100%;
    margin: 0 auto;
    display: flex;
    justify-content: flex-end;
    align-items: center;
  }
}

.add-fund-manager {
  display: flex;
  justify-content: space-between;
  align-items: center;

  .add-button {
    cursor: pointer;
    width: 70px;
    margin-left: 15px;
    text-align: right;
    color: #409eff;
  }
}

.form_slot {
  display: flex;
}
.common_detail {
  /deep/ input {
    border:none;
  }
  /deep/ textarea {
    border:none;
    padding-left: 5px;
  }
  
}
</style>
<style lang="scss">
.pre-fundDetailForm-container {
  .el-range-editor.is-disabled {
    background-color: #fff !important;

    input {
      background-color: #fff !important;
      color: #606266;
    }
  }

  .is-disabled {
    .el-input__inner,
    .el-range-editor,
    .el-textarea__inner {
      background-color: #fff !important;
    }
  }
}
</style>
